import { Inject, Injectable } from '@angular/core';

import { Severity } from 'core/logging/constants';
import { LoggingService } from 'core/logging/logging.service';
import { TranslationCollection } from 'locale/translation.collection';

interface Translation {
  getPlural(n: number): number;
  getTranslations(): any;
}

@Injectable()
export class TranslationService
{
  private translation: Translation;

  constructor(@Inject(LoggingService) private loggingService)
  {
    this.translation =
        TranslationCollection.getTranslationConfig();
  }

  public setTranslationLocale(locale: string): void
  {
    this.translation =
        TranslationCollection.getTranslationConfig(locale);
  }

  public get(key: string, plural?: number, replacements?: any): string
  {
    const translationKeys = Object.keys(this.translation.getTranslations());
    if (translationKeys.indexOf(key) > -1) {
      const translation = this.translation.getTranslations()[key];
      const isPluralFormAvailable = typeof translation !== 'string';

      const pluralTranslation = () => {
        const pluralCount = plural === undefined ? 1 : +plural;
        return translation[this.translation.getPlural(pluralCount)];
      };

      const fillPlaceholders = (_translation) => {
        // given "plural" value
        _translation = _translation
            .replace('{{value}}', plural === undefined ? '' : String(plural));

        // given replacements
        if (replacements) {
          for (let rKey of Object.keys(replacements)) {
            const rValue = replacements[rKey];
            _translation = _translation.replace('{{' + rKey + '}}', rValue);
          }
        }

        // remove unused placeholders
        _translation = _translation.replace(/{{.*?}}/g, '');

        return _translation;
      };

      let translatedString = isPluralFormAvailable
          ? pluralTranslation()
          : String(translation);

      translatedString = fillPlaceholders(translatedString);

      return translatedString;
    }
    else {
      const message = `Translation for key ${key}, plural: ${plural} not found`;
      this.loggingService.log('TranslationService', Severity.ERROR, message);
      return key;
    }
  }

  public getLanguageKeyPrefix(category: string, name: string): string
  {
    return ['i18n', category, name.replace(/^\w/, c => c.toLowerCase())]
      .join('.');
  }

  public translateErrorMessage(
      languageKey: string, references: Array<string>): string
  {
    let _references = {};
    if (references !== undefined) {
      for (let i = 0; i < references.length; i++) {
        _references['reference' + (i + 1)] = references[i];
      }
    }

    return this.get(languageKey + '.message', undefined, _references);
  }
}
